import React from 'react';

const BackIcon = (props) => (
  <svg width={38} height={39} viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={18.92} cy={19.42} r={18.42} fill="#27282D" stroke="#fff" />
    <path
      d="M20.935 15.557l-4.03 3.753M20.935 23.283l-4.03-3.753"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

export default BackIcon;
